import React from 'react';

const GreenTickDot = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="9" fill="#F2F2F2" />
    <circle cx="9" cy="9" r="8" fill="#00A331" />
    <path
      d="M11.3259 6.39913L7.79794 9.92713L6.66994 8.79913C6.43594 8.56513 6.05794 8.56513 5.82394 8.79913C5.58994 9.03313 5.58994 9.41113 5.82394 9.64513L7.37794 11.1991C7.61194 11.4331 7.98994 11.4331 8.22394 11.1991L12.1779 7.24513C12.4119 7.01113 12.4119 6.63313 12.1779 6.39913C11.9439 6.16513 11.5599 6.16513 11.3259 6.39913Z"
      fill="white"
    />
  </svg>
);

export default GreenTickDot;
